/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_4_Paragraphs_1Inputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_4_paragraphs_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_4_Paragraphs_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A sales team maintains a shared forecast and several people update it during the same meeting. Here, the file is only one part of the job. Ownership, simultaneous changes, version history and access management matter too. Before moving that task, verify the complete collaboration workflow. This site’s local GridCraft editor does not provide a replacement for that shared-document process simply because it can display the spreadsheet.`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_4_paragraphs_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_4_Paragraphs_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`销售团队可能在会议中共同维护预测表，多人同时更新。在这个场景里，文件本身只是工作的一部分，所有权、并发修改、版本历史和权限管理同样重要。迁移前要验证完整协作流程。本站本地 GridCraft 编辑器能够显示表格，并不表示它可以替代共享文档流程。`)
};

/**
* | output |
* | --- |
* | "A sales team maintains a shared forecast and several people update it during the same meeting. Here, the file is only one part of the job. Ownership, simulta..." |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_4_Paragraphs_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_4_paragraphs_1 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_4_Paragraphs_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_4_Paragraphs_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_4_paragraphs_1(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_4_paragraphs_1(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_4_paragraphs_1 as "gc.search_guides.gridcraft_vs_excel.sections.4.paragraphs.1" }